<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="结算"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       

        <el-form-item label="姓名" >  
          {{obj.nickname}}
        </el-form-item>

        <el-form-item label="职位">
          {{obj.title}}
        </el-form-item>


        <el-form-item label="入职时间"  >
          <el-date-picker
            v-model="formData.min_time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="离职时间"  >
          <el-date-picker
            v-model="formData.max_time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>


        <el-form-item label="工作时间"  >

          <el-col :span="16">
            <el-input  type="text"  v-model="formData.day_num"></el-input>
          </el-col>
          <el-col :span="8">
            <el-select  placeholder="请选择" v-model="formData.day_type">
              <el-option label="天" value="天"> </el-option>
              <el-option label="月" value="月"> </el-option>
              <el-option label="周" value="周"> </el-option>
            </el-select>
          </el-col>

        </el-form-item>


        <el-form-item label="薪资"  prop="money">
          <el-input  v-model="formData.money"  type="text"></el-input>
        </el-form-item>

        <el-form-item label="支付密码"  prop="pay_password">
          <el-input  v-model="formData.pay_password"  type="text"></el-input>
        </el-form-item>
        

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">发给员工</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
//import { recruitList,jobList,projectList,updateEnroll,sendSalary} from "@/api/director/work/recruit/index";

import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";
export default {

  data() {
    return {
      visible: false,
      obj:{
        nickname:'',
        title:''
      },

      /*
      enroll_id	是	int	报名id
min_time	是	string	开始时间
max_time	是	string	结束时间
day_num	是	int	工作数量
day_type	是	string	量词，天，月，周
money	是	int	工资
pay_password	是	int	支付密码*/
      formData: {
        enroll_id:'',
        min_time:"1",
        max_time:"",
        day_num:"",
        day_type: "",
        money: "",
        pay_password: "",
       
      },
       rules: {
        min_time: [
              {required: true, message: '请选择开始时间', trigger: 'blur'}
          ],
          max_time: [
              {required: true, message: '请选择结束时间', trigger: 'blur'}
          ],
          day_num: [
              {required: true, message: '请输入工作数量', trigger: 'blur'}
          ],
          money: [
              {required: true, message: '请输入工资', trigger: 'blur'}
          ],

          pay_password: [
              {required: true, message: '请输入支付密码', trigger: 'blur'}
          ]


       }
    };
  },

 
  mounted() {

},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init(obj) {
      console.log(obj);
      this.obj=obj;
      this.visible = true;
      this.formData.enroll_id=obj.enroll_id;
    },

  
    
    
    submit(){
      var that=this;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            sendSalary(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
